import { api } from "./api";

export const serverSearchApi = (params) => {
    return api.get(`/server-ips/get`, { params: params });
};

export const serverCreateApi = (params) => {
    return api.post(`/server-ip/add`, params);
};

export const serverEditApi = (params) => {
    return api.post(`/server-ip/update`, params);
};

export const serverDeleteApi = (params) => {
    return api.post(`/server-ip/delete`, params);
};

export const serverUploadApi = (params) => {
    return api.post(`/settings/server/bulk/add`, params);
};
